import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { staffName } from "./staffUtils";

// DELETE /api/admin/staff/:id
const DeleteStaffModal = ({ isOpen, staffMember, onClose, onConfirm, isLoading }) => {
  if (!isOpen || !staffMember) return null;

  return (
    <div
      className="modal"
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1050,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "24px",
          maxHeight: "90vh",
          overflowY: "auto",
          width: "min(90vw, 480px)",
        }}
      >
        <h5 className="text-danger">Delete Staff</h5>

        <div className="mb-3">
          <span className="disableText">
            Are you sure you want to permanently delete
            <span className="text-danger fw-semibold"> {staffName(staffMember)}</span>? This action
            cannot be undone.
          </span>
        </div>

        <div className="formErrorDiv" style={{ marginBottom: "12px" }}>
          <FontAwesomeIcon icon={faInfoCircle} />
          <p className="formError">Deleting a staff account removes their access immediately.</p>
        </div>

        <div className="modal-buttons">
          <button
            type="button"
            className="btn btn-danger"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="spinner-border text-light btnspinner" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              "Delete"
            )}
          </button>
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={isLoading}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteStaffModal;